import moment from 'moment';
import {
  formatSpecificDate,
  DATE_FORMAT,
  YEAR_MONTH_DAY_FORMAT,
} from '@/utils/date';
import { makeToastFaile, unMaskPrice } from '@/utils/common';
import { AMOUNT_TYPE } from '@/utils/enum';

const POSITIVE_INTEGER_REGEX = /^[1-9]\d*$/;

export const validateDealSheetForm = (formData, stores = [], products = []) => {
  if (!formData.name?.trim()) {
    makeToastFaile('Vui lòng nhập tên chương trình!');
    return false;
  }

  if (!formData.code?.trim()) {
    makeToastFaile('Vui lòng nhập mã chương trình!');
    return false;
  }

  if (!formData.startDate) {
    makeToastFaile('Vui lòng nhập thời gian bắt đầu cho dealsheet!');
    return false;
  }

  const formattedStartDate = formatSpecificDate(
    formData.startDate,
    DATE_FORMAT,
    YEAR_MONTH_DAY_FORMAT,
  );
  const formattedEndDate = formatSpecificDate(
    formData.endDate,
    DATE_FORMAT,
    YEAR_MONTH_DAY_FORMAT,
  );
  if (formattedEndDate && !moment(formattedEndDate).isAfter(formattedStartDate)) {
    makeToastFaile('Thời gian không hợp lệ!');
    return false;
  }

  if (!formData.targetMin) {
    makeToastFaile('Vui lòng nhập điều kiện min!');
    return false;
  }

  if (!POSITIVE_INTEGER_REGEX.test(formData.targetMin)) {
    makeToastFaile('Điều kiện min không hợp lệ!');
    return false;
  }

  if (!formData.targetMax) {
    makeToastFaile('Vui lòng nhập điều kiện max!');
    return false;
  }

  if (!POSITIVE_INTEGER_REGEX.test(formData.targetMax)) {
    makeToastFaile('Điều kiện đạt max không hợp lệ!');
    return false;
  }

  if (Number(formData.targetMax) < Number(formData.targetMin)) {
    makeToastFaile('Điều min không được lớn hơn điều kiện max!');
    return false;
  }

  const storesWithoutTarget = stores.filter((item) => !item.targetQuantity);
  if (storesWithoutTarget.length > 0) {
    storesWithoutTarget.forEach((item) => {
      makeToastFaile(`Vui lòng nhập chỉ tiêu cho cửa hàng ${item.name}!`);
    });
    return false;
  }

  if (products.length < 1) {
    makeToastFaile('Vui lòng chọn sản phẩm!');
    return false;
  }

  for (const product of products) {
    if (!product.discountAmount || product.discountAmount <= 0) {
      makeToastFaile(`Mức hỗ trợ cho ${product.productName} không hợp lệ!`);
      return false;
    }

    if (product.discountType === AMOUNT_TYPE.PERCENT) {
      const discountValue = Number(unMaskPrice(product.discountAmount));
      if (discountValue > 100) {
        makeToastFaile(
          `Mức hỗ trợ cho ${product.productName} không được vượt quá 100%!`,
        );
        return false;
      }
    }

    if (!product.targetQuantity || product.targetQuantity <= 0) {
      makeToastFaile(`Chỉ tiêu cho ${product.productName} không hợp lệ!`);
      return false;
    }
  }

  return true;
};
